import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mainbody modulewrap"
};
const _hoisted_2 = {
  class: "subwrap"
};
const _hoisted_3 = {
  class: "newslist"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "newscover"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "newsinfo"
};
const _hoisted_8 = {
  class: "a overdot"
};
const _hoisted_9 = {
  class: "b"
};
const _hoisted_10 = {
  key: 0,
  class: "newspage"
};
const _hoisted_11 = {
  key: 1,
  class: "newsdetail"
};
const _hoisted_12 = {
  class: "subcontitle"
};
const _hoisted_13 = {
  class: "subcondate"
};
const _hoisted_14 = {
  class: "word"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1);
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  class: "subconbtn"
};
export default {
  __name: 'news',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const FFdata = reactive({
      alias: 'news',
      isLoad: false,
      resData: {},
      infodata: [],
      infoDetail: {}
    });
    const getData = async () => {
      let id = route.params.id;
      if (id) {
        proxy.$common.fetch({
          'act': 'sei_newsdetail',
          'exts': 'id=' + id,
          msg: ''
        }, res => {
          FFdata.infoDetail = res.infodata;
          FFdata.isLoad = true;
        });
        proxy.$store.SET_NAVALIAS(FFdata.alias);
      } else {
        getNewsList(0);
      }
    };
    const getNewsList = cpage => {
      proxy.$common.fetch({
        'act': 'sei_news',
        'exts': 'page=' + cpage,
        msg: ''
      }, res => {
        FFdata.infodata = res.infodata;
        FFdata.resData = res;
        FFdata.isLoad = true;
      });
      proxy.$store.SET_NAVALIAS(FFdata.alias);
    };
    const goUrl = id => {
      router.push('/news/' + id);
    };
    onMounted(() => {
      getData();
    });
    watch(() => FFdata.resData.cpage, (newValue, oldValue) => {
      if (oldValue) {
        getNewsList(newValue);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_router_link = _resolveComponent("router-link");
      return _unref(FFdata).isLoad ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.$common.basic.isArrayExist(_unref(FFdata).infodata) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).infodata, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "newsitem",
          key: item.id,
          onClick: $event => goUrl(item.id)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: item.cover
        }, null, 8, _hoisted_6)]), _createElementVNode("dl", _hoisted_7, [_createElementVNode("dt", null, _toDisplayString(_ctx.$common.basic.dateFormat(item.datepublish)), 1), _createElementVNode("dd", _hoisted_8, _toDisplayString(_ctx.$common.langInfo(item.title, item.title_en)), 1), _createElementVNode("dd", _hoisted_9, _toDisplayString(_ctx.$common.basic.strGetLen(item.content, 300)), 1)])], 8, _hoisted_4);
      }), 128))]), _unref(FFdata).resData.recordcount > 3 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        "current-page": _unref(FFdata).resData.cpage,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => _unref(FFdata).resData.cpage = $event),
        total: _unref(FFdata).resData.recordcount,
        "page-size": 3
      }, null, 8, ["current-page", "total"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _ctx.$common.basic.isObjExist(_unref(FFdata).infoDetail) ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$common.langInfo(_unref(FFdata).infoDetail.title, _unref(FFdata).infoDetail.title_en)), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(_ctx.$common.basic.dateFormat(_unref(FFdata).infoDetail.datepublish)), 1)]), _hoisted_15]), _createElementVNode("div", {
        class: "subcon editor2",
        innerHTML: _ctx.$common.langInfo(_unref(FFdata).infoDetail.content, _unref(FFdata).infoDetail.content_en)
      }, null, 8, _hoisted_16), _createElementVNode("div", _hoisted_17, [_createVNode(_component_router_link, {
        to: "/news"
      }, {
        default: _withCtx(() => [_createTextVNode("返回新闻中心")]),
        _: 1
      })])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true);
    };
  }
};